import axiosInstance from "./axiosInstance";
import { LoginRequest, LoginResponse, SignupRequest } from "../types/auth"; // Giả định có types

class AuthService {
  static async login(data: LoginRequest): Promise<LoginResponse> {
    try {
      const response = await axiosInstance.post<ApiResponse<LoginResponse>>(
        "/auth/token",
        data
      );
      return response.data.result;
    } catch (error) {
      throw new Error("Login failed");
    }
  }

  static async outboundLogin(
    provider: string,
    code: string
  ): Promise<LoginResponse> {
    try {
      const response = await axiosInstance.post<any>(
        `/auth/outbound/authentication`,
        {
          provider,
          code,
        }
      );
      return response.data?.result as LoginResponse;
    } catch (error) {
      throw new Error("Outbound login failed");
    }
  }
  static async signup(data: SignupRequest): Promise<LoginResponse> {
    const response = await axiosInstance.post<LoginResponse>("/users", data);
    return response.data;
  }

  static async logout(): Promise<any> {
    const token = localStorage.getItem("token");
    const response = await axiosInstance.post<any>("/auth/logout", { token });
    return response.data;
  }
}

export default AuthService;
